import React from 'react';

import ActionButton from './action-button';

interface PropType {
  buttons: DevTypes.Rule[];
  i18n: DetailTypes.i18n;
  rule: DevTypes.SkuTypeInfo;
  type: SkuTypes.TypeInfo;
  productId: number;
  productOwnMemberAlitalkEncryptId: string;
  productEncryptId: string;
  umidToken: string;
  moq: number;
  price: DetailTypes.Price;
  config: DevTypes.ButtonConfig | any;
}

export default function ActionRule(props: PropType) {
  const { buttons = [], config } = props;
  if (buttons.length === 0) return null;

  const renderButton = (button: DevTypes.Rule, index: number) => {
    let buttonProps: DevTypes.ButtonClass | null = null;
    let target: DevTypes.ButtonTypeInfo | null = null;

    if (typeof button === 'object' && button !== null) {
      target = Object.keys(button)[0] as DevTypes.ButtonTypeInfo;
      if (target in config) {
        buttonProps = { ...config[target], ...button[target] };
      }
    } else if (typeof button === 'string' && button in config) {
      target = button as DevTypes.ButtonTypeInfo;
      buttonProps = config[target];
    }

    return buttonProps && target ? (
      <ActionButton key={index} {...buttonProps} target={target} {...props} />
    ) : null;
  };

  return (
    <div className="button-layout">{buttons.map((item, index) => renderButton(item, index))}</div>
  );
}
